'use strict';

const StaticPages =
  window.StaticPages != null ? window.StaticPages : (window.StaticPages = {});

StaticPages.init = function({ staticPages }, done) {
  if (!staticPages) {
    return done();
  }

  const { staticPageArray, isTouchRequest } = staticPages;

  if (!staticPageArray || !staticPageArray.length) {
    return done();
  }

  let $body = null;
  let $main = null;
  let $pitch = null;

  if (isTouchRequest) {
    $body = $('html, body');
    $main = $('#global-container');
    $pitch = $(
      isTouchRequest ? '.t-pod.toggle-drawer.highlights' : '#about-deal'
    );
  } else {
    $pitch = $('article.pitch');
  }

  const deferreds = staticPageArray.map(
    ({ staticPageType, staticPageId, staticPageHref, formattedAjaxUrl }) => {
      const $staticPage = $(`#${staticPageId}`);
      let $staticPageOpener = $pitch.find(`a[href='${staticPageHref}']`);
      if ($staticPageOpener.length === 0) {
        $staticPageOpener = $pitch.find(`a[data-modal-id='${staticPageId}']`);
      }
      if (
        (!$staticPage || !$staticPage.length) &&
        (!$staticPageOpener || !$staticPageOpener.length)
      ) {
        return;
      }

      $.ajax({
        url: formattedAjaxUrl,
        dataType: 'json',

        success: res => {
          const { title } = res;
          let { bodyHtml } = res;
          if (staticPageType === 'articles') {
            bodyHtml = res.content;
          }
          if ((!bodyHtml || !bodyHtml.length) && (!title || !title.length)) {
            return;
          }

          if (isTouchRequest) {
            // for both Touch Classic and Responsive
            const $sizingChartLink = $(`#sizing-chart-${staticPageId}`); //# link under the variations
            $staticPage.find('header.t-header h2').text(title);
            $staticPage.find('div.t-body-html').html(bodyHtml);

            $staticPage
              .find('a.t-back-link')
              .off()
              .click(() => {
                $staticPage.hide();
                $main.show();
              });

            $staticPage.find('a.t-pane-back-to-top').click(() => {
              $body.animate(
                {
                  scrollTop: 0,
                },
                'median'
              );
            });

            const sizingChartClickHandler = function(event) {
              $main.hide();
              $staticPage.show();
              $body.animate(
                {
                  scrollTop: 0,
                },
                'slow'
              );
              event.preventDefault();
              return false; // don't follow href
            };

            $staticPageOpener.click(sizingChartClickHandler);

            if ($sizingChartLink && $sizingChartLink.length) {
              $sizingChartLink.click(sizingChartClickHandler);
            }
          } else {
            // desktop
            $staticPage.find('h2.section-title').text(title);
            $staticPage.find('div.body-html').html(bodyHtml);
          }
        },

        error: () => {
          if (!isTouchRequest) {
            $staticPageOpener.removeAttr('data-modal-id');
          }
          $staticPageOpener.off(); // strip off listeners and resume to a normal hyperlink
          $staticPage.remove();
        },
      });
    }
  );

  $.when(...deferreds).then(done);
};

module.exports = StaticPages;
